import React, { ComponentProps } from 'react';
import { TitleImage } from '../../../types/api/ImageType';
import { asView, useViewContext } from '../../../_lib/ViewFetcher';
import { Image, ImageModifier } from '../../../components/molecules/Image';

type TitleImageDefaultProps = {
  image?: TitleImage;
};
export function TitleImageDefault({ image }: TitleImageDefaultProps) {
  const { fetchUrl } = useViewContext();

  if (!image) {
    return null;
  }

  return (
    <div className="title-image">
      <Image
        key={image.src}
        image={image}
        modifier={ImageModifier.CENTER_HORIZONTAL}
        responsiveType="teaser"
        fetchUrl={fetchUrl}
      />
    </div>
  );
}
export const TitleImageDefaultView = asView(TitleImageDefault);
export type TitleImageDefaultView = ComponentProps<typeof TitleImageDefaultView>;
